import React, { useState } from 'react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Spinner } from '@/components/ui/spinner'

interface ConfirmationModalProps {
  visible: boolean
  onYes: ({
    confirmedStep1,
    confirmedStep2,
  }: {
    confirmedStep1: boolean
    confirmedStep2: boolean
  }) => void
  onCancel: ({
    confirmedStep1,
    confirmedStep2,
  }: {
    confirmedStep1: boolean
    confirmedStep2: boolean
  }) => void
  yesButtonText?: string
  cancelButtonText?: string
  renderStep1Title: React.ReactNode
  renderStep2Title: React.ReactNode
  hideFooter?: boolean
}

const TwoStepConfirmationModal: React.FC<ConfirmationModalProps> = (props) => {
  const [step, setStep] = useState<number>(1)
  const [confirmedSteps, setConfirmedSteps] = useState<{
    confirmedStep1: boolean
    confirmedStep2: boolean
  }>({ confirmedStep1: false, confirmedStep2: false })
  const { visible, yesButtonText, cancelButtonText, renderStep1Title, renderStep2Title } = props
  const [isLoading, setLoading] = useState<boolean>(false)

  const handleYesClick = async () => {
    if (step === 1) {
      setStep(2)
      setConfirmedSteps({ ...confirmedSteps, confirmedStep1: true })
      return
    }
    setLoading(true)
    await props.onYes({ ...confirmedSteps, confirmedStep2: true })
    setLoading(false)
  }

  const handleNoClick = () => {
    if (step === 1) {
      setConfirmedSteps({ ...confirmedSteps, confirmedStep1: false })
      setStep(2)
    } else {
      setConfirmedSteps({ ...confirmedSteps, confirmedStep2: false })
      if (confirmedSteps.confirmedStep1) {
        props.onYes({ confirmedStep1: true, confirmedStep2: false })
        return
      }
      props.onCancel({ confirmedStep2: false, confirmedStep1: false })
    }
  }

  const renderTitle = () => {
    if (step === 1) {
      return renderStep1Title
    }
    return renderStep2Title
  }

  return (
    <Dialog open={visible} onOpenChange={(open) => !open && handleNoClick()}>
      <DialogContent overlayClassName='z-2060' className='z-2060'>
        <DialogHeader>
          <DialogTitle>Confirmation</DialogTitle>
          <DialogDescription>{renderTitle()}</DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button variant='outline' onClick={handleNoClick} disabled={isLoading}>
            {cancelButtonText || 'Cancel'}
          </Button>
          <Button onClick={handleYesClick} disabled={isLoading}>
            {yesButtonText || 'Confirm'}
            {isLoading && <Spinner />}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default TwoStepConfirmationModal
